import('./bootstrap.js');

export default true;
